const langData = {
  account: {
    'login': 'login',
    'account': 'account'
  }
}

const lang = require.context('@/lang', true, /\.json$/)
lang.keys().map(v => {
  const name = v.split('/')[1]
  langData[name] = require(`@/lang/${name}/en.json`)
})

export default {
  langData
}



// WEBPACK FOOTER //
// ./src/lang/en.js